export default [
    {
        text: 'Beranda',
        to: {
            name: 'home',
            hash: '#home',
        },
        trackerValue: 'menu_beranda',
    },
    {
        text: 'Akun Pembelajaran',
        to: {
            name: 'home',
            hash: '#about',
            trackerValue: 'menu_akun_pembelajaran',
        },
    },
    {
        text: 'Daftar Platform',
        to: {
            name: 'home',
            hash: '#platform',
        },
        trackerValue: 'menu_daftar_platform',
    },
    {
        text: 'Cara Aktivasi',
        to: {
            name: 'home',
            hash: '#cara-aktivasi',
        },
        trackerValue: 'menu_cara_aktifasi',
    },
    {
        text: 'Webinar',
        to: {
            name: 'home',
            hash: '#webinar',
        },
        trackerValue: 'menu_webinar',
    },
    {
        text: 'Pernyataan Pemerintah',
        to: {
            name: 'home',
            hash: '#pernyataan-pemerintah',
        },
        trackerValue: 'menu_pernyataan_pemerintah',
    },
    {
        text: 'FAQ',
        to: {
            name: 'home',
            hash: '#faq',
        },
        trackerValue: 'menu_bantuan',
    },
];
